export enum NotesDrawerParams {
  ClaimSetNumber = 'claimSetNumber',
  NoteId = 'noteId',
  ClaimId = 'claimId',
  Highlight = 'highlight',
  Expanded = 'expanded',
  HasBackButton = 'hasBackButton',
}
